import { api } from "../api/apiClient";

const handleError = (error) => {
  console.error("Error:", error);
  throw error;
};

/**
 * Posts location information to the backend.
 *
 * @param {string} city - The city of the user.
 * @param {string} country - The country of the user.
 * @param {number} latitude - The latitude of the user's location.
 * @param {number} longitude - The longitude of the user's location.
 * @param {boolean} allowLocation - Whether the user allows location tracking.
 * @returns {Promise<object>} The response data from the server.
 */
export const postLocation = async (id, city, country, latitude, longitude) => {
  try {
    const response = await api.post(`/api/location/user-location`, {
      id,
      city,
      country,
      latitude,
      longitude,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

/**
 * Clears location data if user revokes permission in settings.
 * Uses dedicated endpoint that properly nulls coordinates in the database.
 */
export const clearUserLocation = async (id) => {
  try {
    const response = await api.post(`/api/location/clear`, { id });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
